import { Offcanvas } from 'bootstrap';

/** Remove orphaned Bootstrap offcanvas backdrops and body scroll lock. */
export const cleanupOffcanvasBackdrop = () => {
  document.querySelectorAll('.offcanvas-backdrop').forEach((node) => node.remove());
  document.body.classList.remove('offcanvas-open', 'modal-open');
  document.body.style.removeProperty('overflow');
  document.body.style.removeProperty('padding-right');
};

export const hideOffcanvasById = (id) => {
  const el = document.getElementById(id);
  if (!el) {
    cleanupOffcanvasBackdrop();
    return;
  }

  const instance = Offcanvas.getInstance(el);
  if (instance) {
    instance.hide();
    window.setTimeout(cleanupOffcanvasBackdrop, 320);
    return;
  }

  el.classList.remove('show');
  cleanupOffcanvasBackdrop();
};
